import React from 'react';
const defaultWidth = 17;

const Chevron = ({ color, orientation }) => {
  let degreeRotation, customWidth;
  switch (orientation) {
    case 'up':
      degreeRotation = 180;
      break;
    case 'right':
      degreeRotation = 270;
      customWidth = 9;
      break;
    case 'left':
      degreeRotation = 90;
      break;
    case 'down':
    default:
      degreeRotation = 0;
  }
  const width = customWidth || defaultWidth;
  return (
    <svg
      style={{ transform: `rotate(${degreeRotation}deg)` }}
      width={width}
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49469 6.09466L2.40002 0L0.400024 2L8.49469 10.0947L16.5894 2L14.5894 0L8.49469 6.09466Z"
        fill={color}
      />
    </svg>
  );
};

export default Chevron;
